import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { clearV2Form } from 'redux/ducks/Post/actions';
import { requireOrganizationData } from '../../../helpers/dashboard';
import {
  triggerBlockedFailedPaymentModal,
  triggerWaitUntilFailedPaymentProcessModal,
} from 'redux/ducks/Modals';
import {
  blockedByFailedPayment,
  pendingUnblockFailedPayment,
  showBlockedFailedPaymentPopups,
} from 'helpers/payment';
import { userPersonaStartDate } from '@helpers/feature_flags';

export const HELP_LINK = 'https://support.go4.io/job-posters#main-content';

export class SideBarComponent extends Component {
  isActive = path => {
    return this.props.pathname.includes(path);
  };

  hasOrganizationData = () => {
    const { user, authenticated } = this.props;
    return !requireOrganizationData(user, authenticated);
  };

  onClickCreateEvent = () => {
    const { user } = this.props;

    if (pendingUnblockFailedPayment(user)) {
      this.props.toggleWaitUntilFailedPaymentProcess();
      return;
    }

    if (blockedByFailedPayment(user)) {
      this.props.toggleBlockedForFailedPayments();
      return;
    }
  };

  redirectLinkUrl = () => {
    const { user } = this.props;

    if (userPersonaStartDate(user) && !user.userPersona) {
      return '/v2/create-event/persona';
    }

    return '/v2/create-event/setting';
  };

  render() {
    const { user } = this.props;

    return (
      <div className="sideBarComponentV2">
        {user.role === 'Event operator' && this.hasOrganizationData() && (
          <div className="create-job">
            {showBlockedFailedPaymentPopups(user) && !user.failedPaymentBlockOverride ? (
              <button onClick={this.onClickCreateEvent} className="btn btn-primary">
                Create New Job
              </button>
            ) : (
              <Link
                onClick={() => {
                  this.props.click();
                  this.props.clearV2Form();
                }}
                key={'create_event'}
                className="btn btn-primary"
                to="/v2/create-event/setting"
              >
                Create New Job
              </Link>
            )}
          </div>
        )}
        <ul className="links">
          {user.role === 'Patient' && (
            <>
              <li className={`${this.isActive('/patient/dashboard') ? 'active' : ''}`}>
                <Link onClick={() => this.props.click()} key="dashboard" to="/patient/dashboard">
                  Dashboard
                </Link>
              </li>
              <li>
                <Link onClick={() => this.props.click()} key="logout" to="/logout">
                  Log Out
                </Link>
              </li>
            </>
          )}
          {user.role === 'Parent' && (
            <>
              <li className={`${this.isActive('/parent/dashboard') ? 'active' : ''}`}>
                <Link onClick={() => this.props.click()} key="dashboard" to="/parent/dashboard">
                  Dashboard
                </Link>
              </li>
              <li>
                <Link onClick={() => this.props.click()} key="logout" to="/logout">
                  Log Out
                </Link>
              </li>
            </>
          )}
          {user.role === 'Event operator' && this.hasOrganizationData() && (
            <>
              <li className={`${this.isActive('/dashboard') ? 'active' : ''}`}>
                <Link onClick={() => this.props.click()} key="dashboard" to="/dashboard">
                  Dashboard
                </Link>
              </li>
              <li className={`${this.isActive('/v2/upcoming-events') ? 'active' : ''}`}>
                <Link onClick={() => this.props.click()} key="upcoming_shifts" to="/v2/upcoming-events">
                  Upcoming Jobs
                </Link>
              </li>
              <li className={`${this.isActive('/v2/event-drafts') ? 'active' : ''}`}>
                <Link onClick={() => this.props.click()} key="drafts" to="/v2/event-drafts">
                  Drafts
                </Link>
              </li>
              <li className={`${this.isActive('/v2/finances') ? 'active' : ''}`}>
                <Link onClick={() => this.props.click()} key="finances" to="/v2/finances">
                  Finances
                </Link>
              </li>
              <li className={`${this.isActive('/edit-profile') ? 'active' : ''}`}>
                <Link onClick={() => this.props.click()} key="edit_profile" to="/edit-profile">
                  Edit Profile
                </Link>
              </li>
              <li className={`${this.isActive('/edit-payment') ? 'active' : ''}`}>
                <Link onClick={() => this.props.click()} key="edit_payment_information" to="/edit-payment">
                  Edit Payment Information
                </Link>
              </li>
              <li>
                <Link onClick={() => this.props.click()} key="logout" to="/logout">
                  Log Out
                </Link>
              </li>
              <li className={`${this.isActive('/referral') ? 'active' : ''}`}>
                <Link onClick={() => this.props.click()} key="referral" to="/referral">
                  REFER & EARN $$$
                </Link>
              </li>
              <li>
                <a href={HELP_LINK} target="_blank" rel="noopener noreferrer">
                  Help
                </a>
              </li>
            </>
          )}
          {user.role === 'Event operator' && !this.hasOrganizationData() && (
            <>
              <div className={'my-3'} />
              <li>
                <Link onClick={() => this.props.click()} key="logout" to="/logout">
                  Log Out
                </Link>
              </li>
              <li>
                <a href={HELP_LINK} target="_blank" rel="noopener noreferrer">
                  Help
                </a>
              </li>
            </>
          )}
        </ul>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.session.currentUser,
    authenticated: state.session.authenticated,
  };
}

const mapDispatchToProps = dispatch => ({
  clearV2Form: () => dispatch(clearV2Form()),
  toggleBlockedForFailedPayments: () => dispatch(triggerBlockedFailedPaymentModal()),
  toggleWaitUntilFailedPaymentProcess: () => dispatch(triggerWaitUntilFailedPaymentProcessModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SideBarComponent);
